const MAX_AVAILABLE_CALL_QUOTA = 10;
const REPLENISH_INTERVAL_MS = 5000;

export const createRateLimiter = () => {
	let callQuota = MAX_AVAILABLE_CALL_QUOTA;

	setInterval(() => {
		callQuota = Math.min(callQuota + 1, MAX_AVAILABLE_CALL_QUOTA);
	}, REPLENISH_INTERVAL_MS);

	const consume = () => {
		if (callQuota <= 0) return false;
		callQuota--;
		return true;
	};

	return { consume };
};
